import { render, staticRenderFns } from "./ListTable-Detail.vue?vue&type=template&id=ec080250&"
import script from "./ListTable-Detail.vue?vue&type=script&lang=js&"
export * from "./ListTable-Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports